import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { doc, getDoc,  Firestore,  updateDoc,  setDoc,  collection,  query,  where,  getDocs,  limit, addDoc,} from '@angular/fire/firestore';
import { isPlatformBrowser } from '@angular/common';
import { authState, getAuth } from '@angular/fire/auth';
import { catchError, first, tap } from 'rxjs/operators';
import { getApp } from 'firebase/app';
import { serverTimestamp } from 'firebase/firestore';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { Observable, Subject } from 'rxjs';
import { environment } from '../../environments/environment';
import { HelperService } from './helper.service';
@Injectable({
  providedIn: 'root'
})
export class UserService {
  user: any;
  userData: any;
  userContentAccount: any;
  contentAccountMapping: any;
  isLoggedIn: any;
  isVerified: any;
  isBrowser: boolean = false;
  
  private questionsDetailsSub = new Subject<any>();
  questionsDetails$: Observable<any> = this.questionsDetailsSub.asObservable();

  private openSinglePage = new Subject<any>();
  SinglePage$: Observable<any> = this.openSinglePage.asObservable();


  constructor(
    public firestore: Firestore,
    private helperService: HelperService,
    @Inject(PLATFORM_ID) platformId: Object
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
    if (this.isBrowser) {
      this.initUserDataFromSession();
    }
  }

  async initUserDataFromSession(data: any = null) {
    if (this.isBrowser) {
      this.user = data;
      this.contentAccountMapping = await this.getUserContentAccMap();
      this.userContentAccount = this.contentAccountMapping;
      if (this.user?.uid) {
        await this.getUserById(this.user.uid)
          .then((user: any) => {
            if (user) {
              this.user['userData'] = user.data();
              this.userData = user.data();
            }
          })
          .catch((err) => console.log(err));
      }
      return;
    } else {
      this.user = {};
      return;
    }
  }
  async speakText(data: any) {
    try {
      const functions = getFunctions(getApp());
      let textToSpeech = httpsCallable(functions, 'synthesizeSpeech');
      let response: any = await textToSpeech(data);
      response = response.data;
      const bufferData = {
        type: 'audio/mp3', //  MIME type
        data: response.data,
      };
      return this.convertBufferToBlob(bufferData);
    } catch (error) {
      console.log('error while text to speech ', error);
      return false;
    }
  }

  // async GoogleSheetApiRead(data: any){
  //   try {
  //     // https://us-central1-quiz42.cloudfunctions.net/readSheet
  //    const functions = getFunctions(getApp());
  //    let googleSheet =await  httpsCallable( functions ,'readSheet')
  //    let response:any= await googleSheet(data);
  //    console.log("respond one ", response)
  //    response= response.data

  //    console.log("data  resposne ==>", response)
  //    return response
  //   } catch (error) {
  //     console.log("error", error)
  //     return false;
  //   }
  // }

  convertBufferToBlob(bufferData: { type: string; data: number[] }): string {
    // Convert Buffer data to Uint8Array
    const uint8Array = new Uint8Array(bufferData.data);
    // Create Blob from Uint8Array
    const blob = new Blob([uint8Array], { type: bufferData.type });
    // Generate Blob URL
    const blobUrl = URL.createObjectURL(blob);
    return blobUrl;
  }

  userLoggedIn() {
    if (this.user && this.user.email) {
      return true;
    } else return false;
  }
  userVerification() {
    return new Promise((resolve, reject) => {
      if (this.user && this.user.email) {
        const userRef = doc(this.firestore, 'user', this.user.uid);
        let user = null;
        getDoc(userRef)
          .then((doc) => {
            user = doc.data();
            resolve(user);
          })
          .catch((err) => {
            reject(false);
          });
      } else {
        // Get previous loged in details if data is not available on service
        this.getIsLoggedIn()
          .pipe(
            tap(async (user) => {
              if (user) {
                // this.setDataInLocalStorage(user);
                await this.initUserDataFromSession(user);
                if (this.user && this.user['userData']) {
                  resolve(this.user['userData']);
                } else {
                  reject(false);
                }
              } else {
                reject(false);
              }
            }),
            catchError(async (err) => {
              var message =
                'Error while contacting server. Please try after sometime.';
              console.log(message);
              reject(false);
            })
          )
          .subscribe();
      }
    });
  }

  getUser() {
    if (this.user) {
      return this.user;
    }
  }

  getUserById(uid: any) {
    return new Promise((resolve, reject) => {
      if (uid) {
        const userRef = doc(this.firestore, 'user', uid);
        let user = null;
        getDoc(userRef)
          .then((doc) => {
            user = doc.data();
            resolve(doc);
          })
          .catch((err) => {
            reject(false);
          });
      } else reject(false);
    });
  }
  getUserAddress(uid: any) {
    return new Promise(async (resolve, reject) => {
      if (uid) {
        const userAddRef = query(
          collection(this.firestore, 'user', uid, 'address'),
          limit(1)
        );
        let address: any = {};
        await getDocs(userAddRef)
          .then((docs) => {
            docs.forEach((doc: any) => {
              address = doc.data();
              address['id'] = doc.id;
            });
            resolve(address);
          })
          .catch((err) => {
            reject({});
          });
      } else reject({});
    });
  }
  async updateUserVerification(user: any) {
    let usersRef = doc(this.firestore, 'user', user.userId);
    this.isVerified = true;
    await updateDoc(usersRef, {
      verified: this.isVerified,
    });
    return true;
  }
  async updateUserDoc(userId: any,obj:any) {
    let usersRef = doc(this.firestore, 'user', userId);
    await updateDoc(usersRef, obj);
    return true;
  }

  removeUserSession() {
    window.localStorage.removeItem(
      'firebase:authUser:' + environment.firebase.apiKey + ':[DEFAULT]'
    );
  }

  createUser(userData: any) {
    return new Promise((resolve, reject) => {
      setDoc(doc(this.firestore, 'user', userData.userId), userData, {
        merge: true,
      })
        .then((doc) => {
          resolve(doc);
        })
        .catch((err) => {
          reject(false);
        });
    });
  }

  getUserCert() {
    return new Promise(async (resolve, reject) => {
      if (this.user && this.user.uid) {
        const userAddRef = query(collection(this.firestore, 'user', this.user.uid, 'certificate'));
        let cert: any = {};
        await getDocs(userAddRef)
          .then((docs) => {
            docs.forEach((doc: any) => {
              let data = doc.data()
              cert[data.certName] = data; 
            });
            resolve(cert);
          })
          .catch((err) => {
            console.error('Error while getting certificate : ',err)
            reject({});
          });
      } else reject({});
    });
  }

  saveCertificate(certObj: any) {
    return new Promise((resolve, reject) => {
      if (certObj && !certObj.id){
        certObj['id'] = this.helperService.uuidv4();
      }
      setDoc(
        doc(this.firestore, 'user', this.user.uid, 'certificate', certObj['id']),
        certObj,
        { merge: true }
      )
        .then((doc) => {
          resolve(doc);
        })
        .catch((err) => {
          console.log('err : ',err)
          reject(false);
        });
    });
  }

  saveAddress(id: any, address: any) {
    return new Promise((resolve, reject) => {
      if (!id) id = this.helperService.uuidv4();
      setDoc(
        doc(this.firestore, 'user', this.user.uid, 'address', id),
        address,
        { merge: true }
      )
        .then((doc) => {
          resolve(doc);
        })
        .catch((err) => {
          reject(false);
        });
    });
  }
  savePaymentMethod(id: any, paymentDetails: any) {
    return new Promise((resolve, reject) => {
      if (id) {
        paymentDetails['creationDate'] = serverTimestamp();
        paymentDetails['id'] = id;
        setDoc(
          doc(this.firestore, 'user', this.user.uid, 'paymentMethod', id),
          paymentDetails,
          { merge: true }
        )
          .then((doc) => {
            resolve(doc);
          })
          .catch((err) => {
            reject(false);
          });
      } else {
        reject(false);
      }
    });
  }

  async getUserContentAccMap() {
    if (this.user) {
      let contentRef: any = null;
      let queryRef = query(
        collection(this.firestore, 'contentAccountMapping'),
        where('refUserId', '==', this.user.uid)
      );
      await getDocs(queryRef).then((docs) => {
        docs.forEach((doc: any) => {
          if (!contentRef) {
            contentRef = doc.data();
          }
        });
      });
      return contentRef;
    } else {
      return null;
    }
  }

  async getUserContentAccMapByContentId(contentId: any) {
    return new Promise((resolve, reject) => {
      let contentRef: any = null;
      if (contentId) {
        let queryRef = doc(this.firestore, 'contentAccountMapping', contentId);
        getDoc(queryRef)
          .then((docs) => {
            contentRef = docs.data();
            resolve(contentRef);
          })
          .catch((err: any) => {
            console.log(
              'Error found while getting user content account mapping : ',
              err
            );
          });
      } else {
        reject(null);
      }
    });
  }

  setUserContentRef(contentRef: any) {
    this.contentAccountMapping = contentRef;
  }

  getUserContentRef() {
    if (this.contentAccountMapping)
      return JSON.parse(JSON.stringify(this.contentAccountMapping));
    return;
  }

  getUserContentAccount() {
    return JSON.parse(JSON.stringify(this.userContentAccount));
  }

  /**
   * Functions to manage security gaurd state
   */

  getIsLoggedIn() {
    return authState(getAuth()).pipe(first());
  }

  setDataInLocalStorage(user: any) {
    if (user && user.uid)
      window.localStorage.setItem(
        'firebase:authUser:' + environment.firebase.apiKey + ':[DEFAULT]',
        JSON.stringify(user)
      );
  }

  // for collaborator (share)
  getUserDetailsByEmailId(emailId: any) {
    let userData: any;
    return new Promise((resolve, reject) => {
      let queryRef = query(
        collection(this.firestore, 'user'),
        where('emailId', '==', emailId)
      );
      getDocs(queryRef)
        .then((result: any) => {
          result.forEach((doc: any) => {
            userData = doc.data();
          });
          resolve(userData);
        })
        .catch((err) => {
          reject(userData);
        });
    });
  }
  // ===google sheet api===========================

  async googleSheetApiReader(longId: string,SheetId: string,drawslist: any = false) {
    return new Promise(async (resolve, reject) => {
      let url = 'https://us-central1-quiz42.cloudfunctions.net/readSheet';
      let data = { longId, SheetId, };
      const options: any = {  method: 'POST',  body: JSON.stringify(data), };
      try {
        let res = await fetch(url, options);
  
        let data = await res.json();
        // console.log('res', data);
        if (drawslist) {
          let indexOfDataLarge = this.findLargestSubarrayIndex(data.rowData); //
          // console.log(
          //   'index of large ',
          //   indexOfDataLarge,
          //   'headers ==>',
          //   data.headers
          // );
        }
        resolve(data)  
        // let object = this.createKeyedObject(data.rowData,4)
        // console.log("object ", object)
      } catch (error) {
        reject(error)
        console.log('Errror while fetching data', error);
      }
    })
  }
// google sheet write api=================

async googleSheetApiWrite(longId: string,SheetId: string,quizId:string) {
  return new Promise(async (resolve, reject) => {
    let url = 'https://us-central1-quiz42.cloudfunctions.net/writeSheet';
    let data = { longId, SheetId, quizId};
    const options: any = {  method: 'POST',  body: JSON.stringify(data), };
    try {
      let res = await fetch(url, options);
      let data = await res.json();
      resolve(data)  
      // let object = this.createKeyedObject(data.rowData,4)
      // console.log("object ", object)
    } catch (error) {
      reject(error)
      console.log('Errror while fetching data', error);
    }
  })
}
async mimirQuestionDiffSheetApi(spreadsheetId: string,sheetId: string,queDiffData:string) {
 return new Promise((resolve, reject) => {
      try {
        if (spreadsheetId != "" && sheetId != '' && queDiffData.length) {
          const functions = getFunctions(getApp());
          const mimirQuestionDiffSheet:any = httpsCallable(functions, 'mimirQuestionDiffSheet');
          let request = { spreadsheetId, sheetId, queDiffData};
          mimirQuestionDiffSheet(request)
            .then((result: any) => {
              console.log('API Response:', result.data);
              resolve(result.data);
            })
            .catch((err: any) => {
              console.error(`mimirQuestionDiffSheet request error:`, err);
              reject(err);
            });
        } else {
          console.warn("Request data not found");
          reject(new Error("Request data not found"));
        }
      } catch (error: any) {
        console.error("Error while calling method:", error);
        reject(error);
      }
    });
}

async googleSheetApiWriteDashboard(longId: string,SheetId: string,quizId:string  ,leaderboard:boolean=false,LeaderQuizIds:any=[] ) {
  return new Promise(async (resolve, reject) => {
    let url = 'https://us-central1-quiz42.cloudfunctions.net/dashboardGoogleSheet';
    let data = { longId, SheetId, quizId, leaderboard, LeaderQuizIds};
    const options: any = {  method: 'POST',  body: JSON.stringify(data), };
    try {
      let res = await fetch(url, options);
      let data = await res.json();
      resolve(data)  
      // let object = this.createKeyedObject(data.rowData,4)
      // console.log("object ", object)
    } catch (error) {
      reject(error)
      console.log('Errror while fetching data', error);
    }
  })
}




  findLargestSubarrayIndex(data: any) {
    /// to find the header if there were too much desing in the sheet
    let largestIndex = -1;
    let maxLength = 0;

    data.forEach((subarray: any, index: any) => {
      if (subarray.length > maxLength) {
        maxLength = subarray.length;
        largestIndex = index;
      }
    });

    return largestIndex;
  }

  createKeyedObject(data: any, keyIndex: any) {
    const result: any = {};

    data.forEach((subarray: any) => {
      if (subarray[keyIndex] && !result[subarray[keyIndex]]) {
        result[subarray[keyIndex]] = subarray;
      }
    });

    return result;
  }

  isValidGoogleSheetsUrl(url: any) {
    const regex =
      /^https:\/\/docs\.google\.com\/spreadsheets\/d\/([a-zA-Z0-9-_]+)(\/.*)?$/; // Regular expression to match Google Sheets URLs
    return regex.test(url);
  }

  extractIdsFromUrl(url: any) {
    const regex = /\/spreadsheets\/d\/([a-zA-Z0-9-_]+)\/.*gid=([0-9]+)/;
    const match = url.match(regex);
    if (match) {
      const spreadsheetId = match[1];
      const sheetId = match[2];
      return { spreadsheetId, sheetId };
    } else {
      return { spreadsheetId: null, sheetId: null };
    }
  }

  jumpToQuestions(data:any){
    if(data)
    this.questionsDetailsSub.next(data);
  }

  openSinglePageQuestionCreation(data:any){
    if(data)
    this.openSinglePage.next(data);
  }

  async getAllCampaignIdsService(){
    return new Promise(async (resolve, reject) => {
    let uId= this.user.uid
    const userRef = collection(this.firestore, 'EmailCampaigns', uId,'iDListDocs');
    let allIds:any = [];
    try {
      const allDoc= await getDocs(userRef)
        allDoc.forEach((doc:any) => {
          allIds.push(doc.data())
        });
        // console.log("all ids ", allIds)
        let totalId:any=[]
        allIds.forEach((el:any)=>{
            let idList=el.idList
            totalId.push(...idList)
         }
        )
        // console.log("total ids  ", totalId)
        resolve(totalId)
    } catch (error) {
      console.log("something went wrong while getting campaign ids ",  error)
      reject(error)
    }
  
  })
 }
 async createEmailCampaignDoc(id:any, data:any){
  return new Promise(async (resolve, reject) => {
    let uId= this.user.uid
    try {
      let success= await setDoc(doc(this.firestore, "EmailCampaigns",uId ,"campaignList", id), data,{merge:true});
        resolve(success)
    } catch (error) {
      console.log("error while creating campaign doc", error)
      reject(error)
    }
  })
 }

 addIdInDoc(data:any , docIdString:any){
  return new Promise(async (resolve, reject) => {
    let uId= this.user.uid
    try {
      let success= await setDoc(doc(this.firestore, "EmailCampaigns",uId ,"iDListDocs", docIdString), data,{merge:true});
        resolve(success)
    } catch (error) {
      console.log("error while creating campaign doc", error)
      reject(error)
    }
  })
 }

 async getOneEmailCampaignDoc(id:any){
  return new Promise(async (resolve, reject) => {
    let uId= this.user.uid
    const userRef = doc(this.firestore, 'EmailCampaigns', uId, "campaignList", id);
    try {
      let details:any
      let doc=  await getDoc(userRef)
        if(doc){
          details= doc.data()
          resolve(details)
        }

    } catch (error) {
        console.log("error while getting the doc for campaign", error)
        reject(error)
      }
 })
}

//
async getDocWithTagName(value:any){
  return new Promise(async(resolve, reject) => {
    let queryRef = query(
      collection(this.firestore, 'distribution'), where('tagName', '==', value)
    )
    let recipientList:any=[]
    let distributionCollection:any

    try {
      let distributionDetails =await   getDocs(queryRef)
      let subCollectionRef:any
      if(distributionDetails){
        distributionDetails.forEach((doc:any)=>{
          distributionCollection=doc.data()

          const distributionId=doc.id;
          distributionCollection['distributionId']=distributionId
          subCollectionRef = collection(this.firestore, `distribution/${distributionId}/recipient`);
        })
        try {
          const subCollectionSnapshot = await getDocs(subCollectionRef);
          subCollectionSnapshot.forEach((subDoc) => {
            const data=subDoc.data()
            recipientList.push(data)
          })
          const AllData={
            recipientList,
            distributionCollection,
          }

          resolve(AllData);
        } catch (error) {
          console.error("error whiling hitting recipient  ", error)
          reject(error)
        }
      }else{//if distribution is not found with tagName not found 
        reject(null)
      }
    } catch (error) {
      console.error("error whiling hitting Distribution  ", error)
      reject(error)
    }
  });
}

async  getDeliveryReport(messageId = null, recipientDetails:any) {
  return new Promise(async (resolve, reject) => {
    let PromiseeData = [];
    const functions = getFunctions(getApp());
    let checkDeliveryCall = httpsCallable(functions, 'checkDelivery');
    for (let i = 0; i < recipientDetails.length; i++) {
      let id = recipientDetails[i].EmailMsgId;
      if (id) id = id.replace(/[<>]/g, ""); // Remove < and > characters from the id
      let data = { messageId: id };
      PromiseeData.push(checkDeliveryCall(data));
    }
    try {
      //@ts-ignore
      const results = await Promise.allSettled(PromiseeData);
      const successfulResults = results.filter((result:any) => result.status === 'fulfilled').map((result:any) => result.value);
      const failedResults = results.filter((result:any) => result.status === 'rejected').map((result:any) => result.reason);
      resolve({ successfulResults, failedResults });
    } catch (error) {
      reject(error);
      console.log("Error while getting report: ", error);
    }
  });
}


  async updateRecipientEmailData(distributionId:any, recipientId:any , recipientInfo:any){
    return new Promise(async (resolve, reject) => {
      try {
        let recipientRef = doc(this.firestore, `distribution/${distributionId}/recipient`, recipientId);
        const data=    await setDoc(recipientRef, recipientInfo ,{merge:true})
          resolve(true)
      } catch (error) {
        reject(null)
        console.error("error while setting the recipient doc===> ", error)
      }
    })
}

// /contact servies
createContact(data:any) {
  return new Promise((resolve,reject)=>{
  data['creationDate']= serverTimestamp();
  const ref = collection(this.firestore,'contactUs')
  addDoc(ref,data).then((status) => {
      resolve(status)
    }).catch(err => {
      reject(err)
    })
  })
}
}
